import React from 'react';
import PropTypes from 'prop-types';
import style from './BasicTable.module.scss';

function BasicTable({ title = '', headers, rows }) {
  return (
    <section className={style.section}>
      {title !== '' && <h3 className={style.title}>{title}</h3>}

      <table className={style.table}>
        <thead className={style.thead}>
          <tr className={style.thead_tr}>
            {headers.map((header) => (
              <th className={style.th} key={header}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={style.tbody}>
          {rows.map((row) => (
            <tr className={style.tbody_tr} key={row}>
              {row.map((cell) => (
                <td className={style.td} key={cell}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

BasicTable.propTypes = {
  title: PropTypes.string,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default BasicTable;
